import React, { useState, useEffect, useRef } from 'react'
import { Row, Col, Container, Dropdown, Modal, Badge, Form, Button } from 'react-bootstrap'
import SignatureCanvas from 'react-signature-canvas';
import { handleImageUpload } from '../../../api/uploads';
import Card from '../../../components/Card'
import { Link, useNavigate } from 'react-router-dom'
import { apiHandler } from '../../../api/apihandler';
import { 
   NOTIFICATION_DELETE, 
   NOTIFICATION_LIST, 
   NOTIFICATION_READ, 
   CHILD_REGISTRATION_VIEW,
   ILLNESS_REPORTS_LIST,
   ACCIDENT_REPORTS_LIST,
   TEACHERS_ALLERGY_VIEW_API,
   TEACHERS_LUNCH_PLAN_WAIVER_API,
   TEACHERS_PEANUT_POLICY_API,
   EMERGENCY_CONTACTS_LIST,
   DAILY_REPORT_VIEW,
   TEACHERS_MEDICATION_API,
   LEAVE_APPLICATION_API,
   LEAVE_APPLICATION_DETAILS_API,
   LEAVE_APPLICATION_APPROVE_API,
   LEAVE_APPLICATION_REJECT_API,
   TEACHERS_NON_MEDICATION_API,
   ANNOUNCEMENT_VIEW_API
} from '../../../api/constants';
import Moment from 'moment';
import DOMPurify from 'isomorphic-dompurify';
import Swal from 'sweetalert2'
import LoaderModal from '../../../components/loaderModal';
import ErrorBoundary from '../../../components/common/ErrorBoundary';
import RegistrationDetailModal from '../../../components/registrationPacket/RegistrationDetailModal';
import { InView } from "react-intersection-observer";
import { isTeacherLoginProfile } from '../../../utilities/teacherModulePermissions';

// Redux Selector / Action
import { useDispatch, useSelector } from 'react-redux';

// img
import user1 from '../../../assets/images/user/01.jpg'
import user2 from '../../../assets/images/user/02.jpg'
import user3 from '../../../assets/images/user/03.jpg'
import user4 from '../../../assets/images/user/04.jpg'
import user5 from '../../../assets/images/user/05.jpg'
import user6 from '../../../assets/images/user/06.jpg'
import user7 from '../../../assets/images/user/07.jpg'
import user8 from '../../../assets/images/user/08.jpg'
import user9 from '../../../assets/images/user/09.jpg'
import user10 from '../../../assets/images/user/10.jpg'
import user11 from '../../../assets/images/user/11.jpg'
import user12 from '../../../assets/images/user/12.jpg'
import user13 from '../../../assets/images/user/13.jpg'
import user14 from '../../../assets/images/user/14.jpg'
import loader from '../../../assets/images/page-img/page-load-loader.gif'
import NoDataFound from '../../../components/noDataFound';

// Escapes text interpolated into Swal's `html` option (e.g. the announcement
// link/link_text below) so stray quotes/angle-brackets in admin-entered data
// can't break out of the markup we're building around them.
const escapeHtml = (value) => String(value)
   .replace(/&/g, '&amp;')
   .replace(/</g, '&lt;')
   .replace(/>/g, '&gt;')
   .replace(/"/g, '&quot;')
   .replace(/'/g, '&#39;');

const Notification = () => {
   let profileData = (useSelector((state) => state.setting.setting.user_data))
   profileData = profileData ? JSON.parse(profileData) : "";
   const navigate = useNavigate();
   const [notificationlist, setNotificationList] = useState([]);
   const [page, setPage] = useState(1);
   const [maxPage, setMaxPage] = useState(1);
   const [showLoader, setShowLoader] = useState(false);
   const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);
   const [showRegistrationModal, setShowRegistrationModal] = useState(false);
   const [registrationData, setRegistrationData] = useState(null);
   const [loadingRegistration, setLoadingRegistration] = useState(false);
   
   // Modal states for types 13-22
   const [showFormModal, setShowFormModal] = useState(false);
   const [formModalType, setFormModalType] = useState(null);
   const [formModalData, setFormModalData] = useState(null);

   const [markingAllRead, setMarkingAllRead] = useState(false);

   // Teacher approve/reject controls inside the leave application modal
   const [showLeaveDecisionSection, setShowLeaveDecisionSection] = useState(null); // null | 'approve' | 'reject'
   const [leaveAdminComments, setLeaveAdminComments] = useState('');
   const [isSubmittingLeaveDecision, setIsSubmittingLeaveDecision] = useState(false);
   const leaveSignaturePadRef = useRef(null);

   const [isFirst, setIsFirst] = useState(true);
   useEffect(() => {
      window.scrollTo({
         top: 0,
         behavior: "smooth",
      });
      setIsFirst(false)
   }, [isFirst]);

   useEffect(() => {
      getNotificationList(1)
   }, [])

   // Real-time: default.js's socket listener dispatches this the moment the
   // server pushes an updated (higher) unread count, meaning a brand new
   // notification just arrived. Pull page 1 in and splice in whatever is
   // genuinely new so the list reflects it immediately, without disturbing
   // whatever the user has scrolled/paginated into further down.
   useEffect(() => {
      const handleNewNotification = () => {
         mergeInLatestNotifications();
      };
      window.addEventListener('notification-new', handleNewNotification);
      return () => {
         window.removeEventListener('notification-new', handleNewNotification);
      };
   }, []);

   async function mergeInLatestNotifications() {
      try {
         const res = await apiHandler(NOTIFICATION_LIST, "POST", { page: 1, limit: 10 })
         if (res.data?.response?.status === 200) {
            const freshItems = res?.data?.data?.notifications?.data || [];
            setNotificationList((prev) => {
               const prevIds = new Set(prev.map((n) => n?.id));
               const newOnes = freshItems.filter((n) => !prevIds.has(n?.id));
               // Also sync read/unread state for items we already have, in
               // case they were read from another device/tab.
               const synced = prev.map((n) => {
                  const match = freshItems.find((f) => f?.id === n?.id);
                  return match ? { ...n, is_read: match.is_read } : n;
               });
               return newOnes.length > 0 ? [...newOnes, ...synced] : synced;
            });
         }
      } catch (error) {
         console.error(error);
      }
   }

   const loadMore = (inView) => {
      if (inView) {
         if (page < maxPage) {
            getNotificationList(page + 1)
            //console.log("scroll working...", page + 1)
            setPage(page + 1)
         }
      }
   };

   function refreshApi() {
      setPage(1)
      getNotificationList(1)
   }

   async function getNotificationList(pageVal) {
      setShowMoreDataLoader(true)
      //setShowLoader(true)
      try {
         const res = await apiHandler(NOTIFICATION_LIST, "POST", {
            page: pageVal,
            limit: 10
         })
         if (res.data?.response?.status === 200) {
            setMaxPage(res?.data?.data?.notifications?.meta?.last_page)
            if (pageVal === 1) {
               setNotificationList(res?.data?.data?.notifications?.data || [])
            } else {
               setNotificationList(notificationlist.concat(res?.data?.data?.notifications?.data || []))
            }

         } else {
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
      }
      finally {
         setShowMoreDataLoader(false)
         //setShowLoader(false)
      }
   }

   // The backend's read-notification endpoint only ever marks a
   // notification as read - it has no reverse ("unread") direction, so this
   // is intentionally one-way. Marking read is idempotent: only decrement
   // the header badge (via the delta) when the item was actually unread,
   // so re-clicking an already-read row can never push the count negative.
   async function readNotification(notificationId, index) {
      const wasUnread = notificationlist[index]?.is_read !== 1;
      try {
         const res = await apiHandler(NOTIFICATION_READ, "POST", {
            notification_id: notificationId
         })
         if (res.data?.response?.status === 200) {
            let temporaryarray = notificationlist.slice();
            if (temporaryarray[index]) {
               temporaryarray[index]['is_read'] = 1;
            }
            setNotificationList(temporaryarray);
            if (wasUnread) {
               window.dispatchEvent(new CustomEvent('notification-count-refresh', { detail: { delta: -1 } }));
            }
         } else {
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
      }
      finally {
      }
   }

   // Backend has no bulk "mark all as read" endpoint, so page through the
   // full notification list, collect every unread id, and fire the
   // single-notification read call for each (a handful at a time so we
   // don't blast the API with an unbounded burst of parallel requests).
   async function markAllAsRead() {
      if (markingAllRead) return;
      setMarkingAllRead(true);
      try {
         const unreadIds = [];
         let pageToFetch = 1;
         let lastPage = 1;
         do {
            const res = await apiHandler(NOTIFICATION_LIST, "POST", { page: pageToFetch, limit: 50 });
            if (res.data?.response?.status !== 200) break;
            const items = res?.data?.data?.notifications?.data || [];
            items.forEach((item) => {
               if (item?.is_read !== 1 && item?.id != null) unreadIds.push(item.id);
            });
            lastPage = res?.data?.data?.notifications?.meta?.last_page || 1;
            pageToFetch += 1;
         } while (pageToFetch <= lastPage);

         if (unreadIds.length === 0) {
            setMarkingAllRead(false);
            return;
         }

         const chunkSize = 5;
         for (let i = 0; i < unreadIds.length; i += chunkSize) {
            const chunk = unreadIds.slice(i, i + chunkSize);
            await Promise.all(chunk.map((id) => apiHandler(NOTIFICATION_READ, "POST", { notification_id: id })));
         }

         setNotificationList((prev) => prev.map((n) => ({ ...n, is_read: 1 })));
         // Bulk change - let the header reconcile with the server rather
         // than guessing a delta here.
         window.dispatchEvent(new Event('notification-count-refresh'));
      } catch (error) {
         console.error(error);
      } finally {
         setMarkingAllRead(false);
      }
   }

   async function deleteNotification(notificationId, wasUnread) {
      try {
         const res = await apiHandler(NOTIFICATION_DELETE, "DELETE", {
            notification_id: notificationId
         })
         if (res.data?.response?.status === 200) {
            window.dispatchEvent(new CustomEvent('notification-count-refresh', wasUnread ? { detail: { delta: -1 } } : undefined));
            refreshApi()
            // Swal.fire({
            //    title: 'Success',
            //    text: res?.response?.data?.data?.message,
            //    icon: 'success',
            //    confirmButtonText: 'Okay'
            // })
         } else {
            //navigate('/auth/sign-in')
            //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
      }
      finally {
      }
   }

   async function fetchRegistrationDetail(studentId) {
      setLoadingRegistration(true);
      setShowRegistrationModal(true);
      try {
         const res = await apiHandler(CHILD_REGISTRATION_VIEW, "POST", {
            student_id: studentId
         });
         
         if (res.data?.response?.status === 200) {
            const apiData = res.data?.data?.data || res.data?.data || {};
            const userDetails = apiData.user_details || {};
            const registrationPackage = apiData.registration_package || {};
            
            const flattenedData = {
               ...registrationPackage,
               user_details: userDetails,
               child_first_name: userDetails.first_name || registrationPackage.child_first_name,
               child_last_name: userDetails.last_name || registrationPackage.child_last_name,
               child_date_of_birth: userDetails.date_of_birth || registrationPackage.child_date_of_birth || registrationPackage.child_dob
            };
            
            setRegistrationData(flattenedData);
         }
      } catch (error) {
         console.error('Error fetching registration detail:', error);
         setShowRegistrationModal(false);
      } finally {
         setLoadingRegistration(false);
      }
   }

   function idsEqual(left, right) {
      if (left === null || left === undefined || right === null || right === undefined) return false;
      return String(left) === String(right);
   }

   // The User model has no `name` column/accessor - only first_name/last_name
   // - so `student?.name` (used throughout fetchFormDetail below) always
   // read as undefined, leaving "Student Name" as "N/A" in every one of
   // these modals regardless of whether the record itself loaded fine.
   function getStudentFullName(student) {
      return `${student?.first_name || ''} ${student?.last_name || ''}`.trim() || undefined;
   }

   function getCollectionFromResponse(data, keys = []) {
      for (const key of keys) {
         const value = data?.[key];
         if (Array.isArray(value)) return value;
         if (Array.isArray(value?.data)) return value.data;
      }

      if (Array.isArray(data?.data)) return data.data;
      if (Array.isArray(data?.data?.data)) return data.data.data;

      return [];
   }

   function getFallbackRouteForForm(formType, formId) {
      switch (formType) {
         case 'illness':
            return '/dashboard/illness-reports';
         case 'accident':
            return '/dashboard/accident-reports';
         case 'allergy':
            return '/dashboard/allergy-action-plan/list';
         case 'lunch':
            return '/dashboard/lunch-plan-waiver/list';
         case 'peanut':
            return '/dashboard/no-peanut-policy/list';
         case 'emergency':
            return '/dashboard/emergency-contact/list';
         case 'dailyReport':
            if (profileData?.user_type === 4) return '/dashboard/daily-reports';
            return formId ? `/dashboard/app/student-dashboard?reportId=${formId}` : '/dashboard/app/student-dashboard';
         case 'medication':
            return '/dashboard/app/medication/list';
         case 'leave':
            return '/dashboard/app/leave-application';
         case 'nonMedication':
            return '/dashboard/app/non-medication/list';
         default:
            return '/dashboard/app/news-feed';
      }
   }

   async function fetchFormDetail(formType, formId, userId) {
      const fallbackRoute = getFallbackRouteForForm(formType, formId);
      const resolvedUserId = userId || profileData?.id || null;

      // If we don't have a usable user context, skip modal fetch and open the target screen.
      if (!resolvedUserId) {
         setShowFormModal(false);
         setFormModalType(null);
         setFormModalData(null);
         navigate(fallbackRoute);
         return;
      }

      setShowFormModal(true);
      setFormModalType(formType);
      setFormModalData(null); // Set to null initially to show loading
      
      try {
         let endpoint = null;
         let payload = { student_id: resolvedUserId };
         
         switch(formType) {
            case 'illness':
               // No student_id here - like the dedicated Illness Reports page,
               // this list is scoped by the backend to whoever is
               // authenticated (a parent's own child is auto-added by
               // apiHandler; a teacher sees their own reports). Passing a
               // student_id that doesn't match a real student (e.g. the
               // notification only carried the teacher's own id) made the
               // backend return zero rows and silently bounce to the
               // fallback route instead of opening the report.
               endpoint = ILLNESS_REPORTS_LIST;
               payload = { page: 1, limit: 100 };
               break;
            case 'accident':
               // Same reasoning as 'illness' above.
               endpoint = ACCIDENT_REPORTS_LIST;
               payload = { page: 1, limit: 100 };
               break;
            case 'allergy':
               endpoint = TEACHERS_ALLERGY_VIEW_API;
               payload = { student_id: resolvedUserId };
               break;
            case 'lunch':
               endpoint = TEACHERS_LUNCH_PLAN_WAIVER_API;
               payload = { student_id: resolvedUserId };
               break;
            case 'peanut':
               endpoint = TEACHERS_PEANUT_POLICY_API;
               payload = { student_id: resolvedUserId };
               break;
            case 'emergency':
               endpoint = EMERGENCY_CONTACTS_LIST;
               payload = { page: 1, limit: 100, student_id: resolvedUserId };
               break;
            case 'dailyReport':
               endpoint = DAILY_REPORT_VIEW;
               payload = { report_id: formId, student_id: resolvedUserId };
               break;
            case 'medication':
               endpoint = TEACHERS_MEDICATION_API;
               payload = { student_id: resolvedUserId };
               break;
            case 'leave':
               // /list is scoped to the caller's own student_id - for a
               // teacher that always resolves to their own account (never a
               // real student), so it silently came back empty regardless of
               // which student's leave application the notification was
               // actually about. /details fetches the one application
               // directly by its own id and (server-side) accepts an
               // explicit student_id override for a teacher, checked against
               // their actual students - not the same as the unrelated
               // /teacher/* routes, which are a teacher's own staff leave.
               if (isTeacherLoginProfile(profileData)) {
                  endpoint = LEAVE_APPLICATION_DETAILS_API;
                  payload = { id: formId, student_id: resolvedUserId };
               } else {
                  endpoint = LEAVE_APPLICATION_API;
                  payload = { page: 1, limit: 100, student_id: resolvedUserId };
               }
               break;
            case 'nonMedication':
               endpoint = TEACHERS_NON_MEDICATION_API;
               payload = { student_id: resolvedUserId };
               break;
            default:
               setShowFormModal(false);
               setFormModalType(null);
               setFormModalData(null);
               navigate(fallbackRoute);
               return;
         }
         
         console.log('Fetching form detail:', { formType, formId, userId, endpoint, payload });
         const res = await apiHandler(endpoint, "POST", payload);
         console.log('API Response:', res.data);
         
         if (res.data?.response?.status === 200) {
            let formData = null;
            
            // Extract the specific record based on formId
            if (formType === 'illness') {
               const reports = getCollectionFromResponse(res.data?.data, ['reports', 'illness_reports']);
               formData = reports.find(report => idsEqual(report?.id, formId)) || reports[0];
            } else if (formType === 'accident') {
               const reports = getCollectionFromResponse(res.data?.data, ['reports', 'accident_reports']);
               formData = reports.find(report => idsEqual(report?.id, formId)) || reports[0];
            } else if (formType === 'emergency') {
               const contacts = getCollectionFromResponse(res.data?.data, ['emergency_contacts', 'contacts']);
               formData = contacts.find(contact => idsEqual(contact?.id, formId)) || contacts[0];
            } else if (formType === 'leave') {
               // /details (used for a teacher) returns the single requested
               // application under `data.data` (the controller's own
               // response.api({data: leaveApplication, message}) payload
               // becomes res.data.data, so the record itself is one level
               // deeper) - unlike the self-scoped /list a student/parent
               // hits above.
               const rawLeave = isTeacherLoginProfile(profileData)
                  ? res.data?.data?.data
                  : (() => {
                     const leaves = getCollectionFromResponse(res.data?.data, ['leave_applications', 'leaves']);
                     return leaves.find(leave => idsEqual(leave?.id, formId)) || leaves[0];
                  })();
               // The API preloads `student` (first_name/last_name/email) on
               // each row, but never a flat `student_name` - map it here the
               // same way the other form types below do. `status` is a
               // numeric code (0 pending / 1 approved / 2 rejected - see
               // LeaveApplicationController.ts), not the string the modal
               // below compares against, so translate it too instead of it
               // always falling through to the "Pending" badge.
               formData = rawLeave ? {
                  ...rawLeave,
                  student_name: getStudentFullName(rawLeave.student),
                  status: rawLeave.status === 1 ? 'Approved' : rawLeave.status === 2 ? 'Rejected' : 'Pending',
               } : null;
            } else if (formType === 'dailyReport') {
               formData = res.data?.data?.report || res.data?.data?.daily_report || res.data?.data;
            } else if (formType === 'allergy') {
               const rawData = res.data?.data;
               if (rawData?.student && (rawData?.allergy_action_plan || rawData?.allergy_report)) {
                  const allergyData = rawData.allergy_action_plan || rawData.allergy_report;
                  formData = {
                     ...allergyData,
                     student_name: getStudentFullName(rawData.student),
                     child_name: getStudentFullName(rawData.student),
                     student_email: rawData.student?.email,
                     student_photo: rawData.student?.photo,
                     // Map allergy report fields
                     allergies: allergyData?.symptoms || allergyData?.allergies || allergyData?.allergy_type,
                     allergy_type: allergyData?.symptoms || allergyData?.allergy_type,
                     severity: allergyData?.require_epi_pen ? 'severe' : 'moderate',
                     reaction: allergyData?.symptoms || allergyData?.allergic_reaction || allergyData?.reaction,
                     treatment: allergyData?.emergency_treatment_procedures || allergyData?.emergency_treatment || allergyData?.treatment,
                     notes: allergyData?.location_of_epi_pen || allergyData?.notes,
                     signature: allergyData?.parent_signature || allergyData?.signature,
                     signed_date: allergyData?.parent_signature_date || allergyData?.signed_date
                  };
               } else {
                  formData = res.data?.data?.allergy_action_plan || res.data?.data?.allergy_report || res.data?.data?.allergy || res.data?.data;
               }
            } else if (formType === 'lunch') {
               // The lunch-plan-waiver/view API nests the actual waiver
               // record under `waiver` (not `lunch_plan_waiver`), and the
               // waiver record itself has no "waiver type"/"effective
               // date"/"parent name" fields - it only has fillup_date,
               // reason, parent_signature_date, signature images and a
               // numeric status. Map those real fields onto the keys the
               // modal below actually reads.
               const rawData = res.data?.data;
               const waiver = rawData?.waiver || rawData?.lunch_plan_waiver;
               if (rawData?.student && waiver) {
                  formData = {
                     ...waiver,
                     student_name: getStudentFullName(rawData.student),
                     child_name: getStudentFullName(rawData.student),
                     student_email: rawData.student?.email,
                     student_photo: rawData.student?.photo,
                     submitted_date: waiver?.fillup_date,
                     signed_date: waiver?.parent_signature_date,
                     parent_signature: waiver?.parents_signature,
                     supervisor_signature: waiver?.supervisor_signature,
                     status: waiver?.status === 1 ? 'active' : 'inactive'
                  };
               } else {
                  formData = res.data?.data?.lunch_plan_waiver || res.data?.data?.lunch_plan || res.data?.data;
               }
            } else if (formType === 'peanut') {
               // Try multiple possible data structures
               const rawData = res.data?.data;
               if (rawData?.student && rawData?.policy) {
                  // Merge student and policy data
                  formData = {
                     ...rawData.policy,
                     student_name: getStudentFullName(rawData.student),
                     student_email: rawData.student?.email,
                     student_photo: rawData.student?.photo,
                     child_name: getStudentFullName(rawData.student),
                     signature: rawData.policy?.parent_signature,
                     signed_date: rawData.policy?.parent_signature_date,
                     date_signed: rawData.policy?.parent_signature_date,
                     acknowledged: rawData.policy?.status === 1 || rawData.policy?.status === true,
                     parent_name: rawData.policy?.parent_name || 'N/A',
                     has_peanut_allergy: rawData.policy?.has_peanut_allergy || false
                  };
               } else {
                  formData = res.data?.data?.peanut_policy || 
                            res.data?.data?.policy || 
                            res.data?.data?.no_peanut_policy ||
                            res.data?.data?.peanutPolicy ||
                            res.data?.data;
               }
               // If data is nested in an array, get the first item
               if (Array.isArray(formData)) {
                  formData = formData[0] || formData;
               }
            } else if (formType === 'medication') {
               const rawData = res.data?.data;
               if (rawData?.student && rawData?.medication) {
                  formData = {
                     ...rawData.medication,
                     student_name: getStudentFullName(rawData.student),
                     child_name: getStudentFullName(rawData.student),
                     student_email: rawData.student?.email,
                     student_photo: rawData.student?.photo
                  };
               } else {
                  formData = res.data?.data?.medication || res.data?.data?.medications || res.data?.data;
               }
            } else if (formType === 'nonMedication') {
               const rawData = res.data?.data;
               if (rawData?.student && rawData?.non_medication) {
                  formData = {
                     ...rawData.non_medication,
                     student_name: getStudentFullName(rawData.student),
                     child_name: getStudentFullName(rawData.student),
                     student_email: rawData.student?.email,
                     student_photo: rawData.student?.photo
                  };
               } else {
                  formData = res.data?.data?.non_medication || res.data?.data?.non_medications || res.data?.data;
               }
            } else {
               formData = res.data?.data || {};
            }
            
            console.log('Extracted form data:', formData);
            
            if (!formData || (Array.isArray(formData) && formData.length === 0)) {
               Swal.fire({
                  icon: 'info',
                  title: 'No Data',
                  text: 'No form details found for this notification.'
               });
               setShowFormModal(false);
               navigate(fallbackRoute);
               return;
            }
            
            setFormModalData(formData);
         } else {
            setShowFormModal(false);
            setFormModalType(null);
            setFormModalData(null);
            navigate(fallbackRoute);
         }
      } catch (error) {
         console.error('Error fetching form detail:', error);
         setShowFormModal(false);
         setFormModalType(null);
         setFormModalData(null);
         navigate(fallbackRoute);
      }
   }

   function handleClearLeaveSignature() {
      if (leaveSignaturePadRef.current) {
         leaveSignaturePadRef.current.clear();
      }
   }

   // Approve/reject a leave application from inside this modal - only shown
   // to a teacher viewing one of their own students' pending applications
   // (see the render block below). Mirrors the admin Laravel panel's own
   // approve/reject behavior: a signature is required to approve, a reason
   // is required to reject.
   async function handleApproveLeaveApplication() {
      if (!leaveSignaturePadRef.current || leaveSignaturePadRef.current.isEmpty()) {
         Swal.fire({
            title: 'Warning',
            text: 'Please provide your signature before approving.',
            icon: 'warning',
            confirmButtonText: 'Okay'
         })
         return;
      }

      setIsSubmittingLeaveDecision(true)
      try {
         const signatureDataURL = leaveSignaturePadRef.current.toDataURL('image/png');
         const signatureBlob = await fetch(signatureDataURL).then(res => res.blob());
         const signatureFile = new File([signatureBlob], `admin_signature_${Date.now()}.png`, { type: 'image/png' });
         const signatureUrl = await handleImageUpload(signatureFile, 'signatures/', 'image/png');

         const res = await apiHandler(LEAVE_APPLICATION_APPROVE_API, "POST", {
            id: formModalData?.id,
            admin_comments: leaveAdminComments.trim(),
            admin_signature: signatureUrl
         })
         if (res.data?.response?.status === 200) {
            Swal.fire({
               title: 'Success',
               text: res?.data?.data?.message || 'Leave application approved successfully',
               icon: 'success',
               confirmButtonText: 'Okay'
            })
            setShowFormModal(false);
            setFormModalType(null);
            setFormModalData(null);
            setShowLeaveDecisionSection(null);
            setLeaveAdminComments('');
            setNotificationList([])
            getNotificationList(1)
         } else {
            Swal.fire({
               title: 'Error',
               text: res?.response?.data?.data?.errors?.[0] || res?.response?.data?.data?.message || 'Failed to approve leave application',
               icon: 'error',
               confirmButtonText: 'Okay'
            })
         }
      } catch (error) {
         console.error(error);
         Swal.fire({
            title: 'Error',
            text: 'Something went wrong. Please try again.',
            icon: 'error',
            confirmButtonText: 'Okay'
         })
      }
      finally {
         setIsSubmittingLeaveDecision(false)
      }
   }

   async function handleRejectLeaveApplication() {
      if (!leaveAdminComments || leaveAdminComments.trim() === '') {
         Swal.fire({
            title: 'Warning',
            text: 'Please provide a reason for rejecting this application.',
            icon: 'warning',
            confirmButtonText: 'Okay'
         })
         return;
      }

      setIsSubmittingLeaveDecision(true)
      try {
         const res = await apiHandler(LEAVE_APPLICATION_REJECT_API, "POST", {
            id: formModalData?.id,
            admin_comments: leaveAdminComments.trim()
         })
         if (res.data?.response?.status === 200) {
            Swal.fire({
               title: 'Success',
               text: res?.data?.data?.message || 'Leave application rejected successfully',
               icon: 'success',
               confirmButtonText: 'Okay'
            })
            setShowFormModal(false);
            setFormModalType(null);
            setFormModalData(null);
            setShowLeaveDecisionSection(null);
            setLeaveAdminComments('');
            setNotificationList([])
            getNotificationList(1)
         } else {
            Swal.fire({
               title: 'Error',
               text: res?.response?.data?.data?.errors?.[0] || res?.response?.data?.data?.message || 'Failed to reject leave application',
               icon: 'error',
               confirmButtonText: 'Okay'
            })
         }
      } catch (error) {
         console.error(error);
         Swal.fire({
            title: 'Error',
            text: 'Something went wrong. Please try again.',
            icon: 'error',
            confirmButtonText: 'Okay'
         })
      }
      finally {
         setIsSubmittingLeaveDecision(false)
      }
   }

   function generateURL(elm) {
      const type = Number(elm?.type);
      const feedType = Number(elm?.feed_type);
      const valueId = elm?.value_id || elm?.valueId || elm?.form_id || elm?.id || null;
      const userId = elm?.user_id || elm?.student_id || elm?.user?.id || profileData?.id || null;
      const friendSlug = elm?.value_slug || elm?.user?.slug || elm?.value_id;
      let dynaMicURL = null

      // Every notification type is handled explicitly by the switch below.
      // A shape assumption inside any single case (e.g. a field the backend
      // didn't actually send for this particular notification) failing
      // shouldn't crash the whole page - catch it here and fall back to the
      // same "Coming Soon" message an unrecognized type gets, instead of an
      // uncaught exception reaching React with no boundary to catch it.
      try {

      // Notification Types:
      // 0: Follow, 1: Comment, 2: Participate, 3: Dance corner post, 4: Challenge post
      // 5: Winner, 6: Like, 7: Tag, 8: Hire, 9: Feed post, 10: Event, 11: Class
      // 12: Form submission, 13: Illness report, 14: Accident report
      // 15: Allergy action plan, 16: Lunch plan waiver, 17: No peanut policy
      // 18: Emergency contact, 19: Daily report published, 20: Medication administered
      // 21: Leave application, 22: Non-medication administered
      // 23: Attendance recorded, 24: Attendance checked out
      // 30: New chat message (direct or group), 40: Billing statement
      // 41: Emergency day, 42: Public announcement
      
      switch (type) {
         case 0: // Follow (Follow Request)
            dynaMicURL = `/dashboard/app/friend-request`
            break
         case 1: // Comment
            if (feedType === 0) {
               dynaMicURL = valueId ? `/dashboard/app/feedDetails/${valueId}` : `/dashboard/app/news-feed`
            } else {
               dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/dashboard/app/news-feed`
            }
            break
         case 2: // Participate
            dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/dashboard/app/news-feed`
            break
         case 3: // Dance corner post
            dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/dashboard/app/news-feed`
            break
         case 4: // Challenge post
            dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/dashboard/app/news-feed`
            break
         case 5: // Winner
            dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/dashboard/app/news-feed`
            break
         case 6: // Like
            if (feedType === 0) {
               dynaMicURL = valueId ? `/dashboard/app/feedDetails/${valueId}` : `/dashboard/app/news-feed`
            } else {
               dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/dashboard/app/news-feed`
            }
            break
         case 7: // Tag
            if (feedType === 0) {
               dynaMicURL = valueId ? `/dashboard/app/feedDetails/${valueId}` : `/dashboard/app/news-feed`
            } else {
               dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/dashboard/app/news-feed`
            }
            break
         case 8: // Hire
            dynaMicURL = friendSlug ? `/dashboard/app/friend-profile/${friendSlug}` : `/dashboard/app/news-feed`
            break
         case 9: // Feed post
            if (feedType === 0) {
               dynaMicURL = valueId ? `/dashboard/app/feedDetails/${valueId}` : `/dashboard/app/news-feed`
            } else {
               dynaMicURL = valueId ? `/dashboard/app/challengeDetails/${valueId}` : `/dashboard/app/news-feed`
            }
            break
         case 10: // Event
            dynaMicURL = `/dashboard/app/publicEvents`
            break
         case 11: // Class
            dynaMicURL = `/dashboard/app/news-feed`
            break
         case 12: // Form submission (Registration Package)
            if (userId) {
               fetchRegistrationDetail(userId);
            } else {
               dynaMicURL = '/dashboard/child-registration/list';
            }
            break
         case 13: // Illness report
               // A teacher already has the real Illness Report view (the
               // same one opened from the Attendance page's per-student
               // "Illness" button) - matches the actual intake form's
               // fields, including signatures - so send them there instead
               // of this page's own separate, more limited modal. A
               // student/parent has no access to that page, so they keep
               // falling through to fetchFormDetail below unchanged.
               if (userId && isTeacherLoginProfile(profileData)) {
                  navigate(`/dashboard/app/attendance?openIllnessReportStudentId=${userId}`);
                  return;
               }
               fetchFormDetail('illness', valueId, userId);
               return;
            break
         case 14: // Accident report
               // Same reasoning as the Illness report case above.
               if (userId && isTeacherLoginProfile(profileData)) {
                  navigate(`/dashboard/app/attendance?openAccidentReportStudentId=${userId}`);
                  return;
               }
               fetchFormDetail('accident', valueId, userId);
               return;
            break
         case 15: // Allergy action plan
               // Same reasoning as the Accident/Illness/Medication cases
               // above - reuse the Attendance page's real "Allergy & Food
               // Preference" modal (the "Allergy Action Plans" button)
               // instead of this page's own limited, separately-maintained
               // modal.
               if (userId && isTeacherLoginProfile(profileData)) {
                  navigate(`/dashboard/app/attendance?openAllergyStudentId=${userId}`);
                  return;
               }
               fetchFormDetail('allergy', valueId, userId);
               return;
            break
         case 16: // Lunch plan waiver
               // Same reasoning as the Allergy case above.
               if (userId && isTeacherLoginProfile(profileData)) {
                  navigate(`/dashboard/app/attendance?openLunchPlanStudentId=${userId}`);
                  return;
               }
               fetchFormDetail('lunch', valueId, userId);
               return;
            break
         case 17: // No peanut policy
               // Same reasoning as the Allergy case above.
               if (userId && isTeacherLoginProfile(profileData)) {
                  navigate(`/dashboard/app/attendance?openPeanutPolicyStudentId=${userId}`);
                  return;
               }
               fetchFormDetail('peanut', valueId, userId);
               return;
            break
         case 18: // Emergency contact
               // For a TEACHER recipient (the "parent/student updated their
               // emergency contact" flow - UserFormsController.ts's
               // formEmergencyContact), value_id carries the actual student
               // id, not the submitter's own account or the EmergencyContact
               // record's id. Deep-link straight into the teacher's own
               // Emergency Contacts page (the current registration_package-
               // based source, not the old EmergencyContact list) so it
               // auto-opens that exact student's detail popup, instead of
               // the wrong/empty result the fetchFormDetail path below gave.
               // A student/parent recipient (the separate admin-authored
               // EmergencyContactController.php flow, where value_id is the
               // EmergencyContact record's own id) has no equivalent page to
               // deep-link into yet, so that case still falls through to the
               // existing fetchFormDetail behavior below unchanged.
               if (valueId && isTeacherLoginProfile(profileData)) {
                  navigate(`/dashboard/app/teacher-emergency-contacts?studentId=${valueId}`);
                  return;
               }
               fetchFormDetail('emergency', valueId, userId);
               return;
            break
         case 19: // Daily report published
               dynaMicURL = getFallbackRouteForForm('dailyReport', valueId);
            break
         case 20: // Medication administered
               // Same reasoning as the Accident/Illness Report cases above -
               // the Attendance page already has the real "Medication
               // Overview" modal (opened from the per-student "Administer
               // Meds" button), matching the actual intake form's fields.
               // Send a teacher there instead of this page's own limited,
               // separately-maintained modal.
               if (userId && isTeacherLoginProfile(profileData)) {
                  navigate(`/dashboard/app/attendance?openMedicationStudentId=${userId}`);
                  return;
               }
               fetchFormDetail('medication', valueId, userId);
               return;
            break
         case 21: // Leave application
         case 25: // Leave application approved
         case 26: // Leave application rejected
               fetchFormDetail('leave', valueId, userId);
               return;
            break
         case 22: // Non-medication administered
               // Same reasoning as the Medication case above.
               if (userId && isTeacherLoginProfile(profileData)) {
                  navigate(`/dashboard/app/attendance?openNonMedicationStudentId=${userId}`);
                  return;
               }
               fetchFormDetail('nonMedication', valueId, userId);
               return;
            break
         case 23: // Attendance recorded (present/absent/on-leave)
         case 24: // Attendance checked out
               // Always the student themselves + their parents (never a
               // teacher - see AttendanceController.ts's
               // notifyAttendanceEvent), so this always lands on the
               // viewer's own Attendance tab, the same Month Snapshot/
               // Calendar view the Profile page's own Attendance tab opens -
               // no student override needed since it defaults to "me/my
               // active child" already.
               navigate('/dashboard/app/profile', { state: { activeTab: 'Attendance' } });
               return;
            break
         case 30: // New chat message (direct or group - see feed_type)
            // The chat page is registered at /chat/index (see chat-router.js
            // and the sidebar's own link to it), not under /dashboard/app/ -
            // building the wrong prefix here sent every chat notification to
            // a route that doesn't exist, showing React Router's "404 Not
            // Found" error page instead of opening the conversation.
            if (feedType === 1 && elm?.chat_group?.slug) {
               // Group message: value_id is the group id, resolved to its
               // slug via the chat_group preload (FeedController.notifications).
               dynaMicURL = `/chat/index?type=group&slug=${elm.chat_group.slug}`
            } else if (elm?.user?.slug) {
               // Direct message: elm.user IS the sender, i.e. the other
               // party in this conversation - exactly what chat.js's own
               // deep-link (?type=user&slug=...) expects to auto-open.
               dynaMicURL = `/chat/index?type=user&slug=${elm.user.slug}`
            } else {
               dynaMicURL = `/chat/index`
            }
            break
         case 40: // Billing statement
            dynaMicURL = '/dashboards/app/my-transactions'
            break
         case 41: // Emergency day (admin panel's HolidayController) - no
                  // dedicated detail page, the description already says it all.
            return;
         case 42: // Public announcement - shown in full via Swal rather than
                  // navigating anywhere, same as the AnnouncementBanner's own
                  // details modal (see components/AnnouncementBanner.js).
            (async () => {
               try {
                  const res = await apiHandler(ANNOUNCEMENT_VIEW_API, 'POST', { id: valueId });
                  const announcement = res?.data?.data?.announcement;
                  const detailsHtml = announcement?.announcement_details || elm?.description || '';
                  // Same optional CTA the AnnouncementBanner/school-announcements
                  // detail modals render - only when the admin set both a link
                  // and its label (see harmonydaycare-api's AnnouncementController).
                  const linkHtml = (announcement?.link && announcement?.link_text)
                     ? `<div style="margin-top:14px;"><a href="${escapeHtml(announcement.link)}" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-primary">${escapeHtml(announcement.link_text)}</a></div>`
                     : '';
                  Swal.fire({
                     icon: 'info',
                     title: 'Announcement',
                     html: `${detailsHtml}${linkHtml}`,
                     confirmButtonText: 'Close'
                  });
               } catch (error) {
                  Swal.fire({ icon: 'error', title: 'Failed to load announcement', text: elm?.description || '' });
               }
            })();
            return;
         default:
            // Whatever this notification type is, none of the cases above
            // recognize it - rather than guessing where to send the user
            // (and risking landing somewhere wrong, or on a page that
            // assumes data this notification doesn't have), show a safe
            // "not available yet" message instead. Same principle as the
            // app's own ComingSoonScreen fallback for unhandled types.
            showComingSoon();
            return;
      }

      if (dynaMicURL) {
         navigate(dynaMicURL)
      }
      } catch (error) {
         console.error('Error handling notification click:', error);
         showComingSoon();
      }
   }

   function showComingSoon() {
      Swal.fire({
         icon: 'info',
         title: 'Coming Soon',
         text: "This notification type isn't supported here yet.",
         confirmButtonText: 'OK'
      });
   }

   return (
      <ErrorBoundary message="The notification list ran into an unexpected error.">
         <LoaderModal showLoader={showLoader} />
         <div id='content-page' className='content-page'>
            <Container>
               <Row>
                  <Col sm="12">
                     <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="card-title mb-0">Notification</h4>
                        {notificationlist.some((n) => n?.is_read !== 1) && (
                           <Link
                              to="#"
                              className={`btn btn-sm btn-primary ${markingAllRead ? 'disabled' : ''}`}
                              onClick={(e) => { e.preventDefault(); markAllAsRead(); }}
                           >
                              {markingAllRead ? 'Marking all as read...' : 'Mark all as read'}
                           </Link>
                        )}
                     </div>
                  </Col>
                  <Col sm="12">
                     {
                        notificationlist.length > 0 ?
                           <div>
                              {
                                 notificationlist.map((elm, i) => (
                                    <Link to="#"//to={generateURL(elm)}
                                    >
                                       {
                                          elm?.is_read === 1 ?
                                             <Card className="card_read_background_color">
                                                <Card.Body >
                                                   <ul className="notification-list m-0 p-0">
                                                      <li className="d-flex ">
                                                         <div className="user-img img-fluid"
                                                            onClick={(e) => {
                                                               e.stopPropagation();
                                                               navigate(profileData?.user_type === 4 ? "#" : `/dashboard/app/friend-profile/${elm?.user?.slug}`)
                                                            }}>
                                                            <img src={elm?.user?.user_setting?.photo ?
                                                               elm?.user?.user_setting?.photo :
                                                               "https://uzone360live.s3.amazonaws.com/noimage.png"}
                                                               alt="story-img" className="rounded-circle avatar-40" />
                                                         </div>
                                                         <div style={{ width: "97%" }}
                                                            onClick={(e) => {
                                                               // The whole row is wrapped in a <Link to="#"> (see the
                                                               // map() above) whose own click handling otherwise fires
                                                               // right after this one via event bubbling, navigating
                                                               // to "#" and silently stripping off any query string
                                                               // generateURL() just navigated to (e.g. the
                                                               // ?openAccidentReportStudentId=... deep link into the
                                                               // Attendance page's real report modal) before the
                                                               // target page could ever read it. preventDefault too,
                                                               // in case the browser's own native <a href="#"> jump
                                                               // fires instead of Link's React Router handler once
                                                               // that handler is stopped from running.
                                                               e.preventDefault();
                                                               e.stopPropagation();
                                                               generateURL(elm)
                                                            }}>
                                                            <div className=" ms-3">
                                                               <h6>{elm?.description}</h6>
                                                               <p className="mb-0">{Moment(elm?.created_at).format('MMM D YYYY')}</p>
                                                            </div>
                                                         </div>
                                                         <div style={{ width: "3%" }}>
                                                            <div className="d-flex " style={{ alignItems: "right" }}>
                                                               <div className="d-flex align-items-center">
                                                                  <div className="card-header-toolbar d-flex align-items-center">
                                                                     <Dropdown>
                                                                        <Link to="#">
                                                                           <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                                              more_horiz
                                                                           </Dropdown.Toggle>
                                                                        </Link>
                                                                        <Dropdown.Menu className="dropdown-menu-right">
                                                                           {
                                                                              elm?.is_read !== 1 &&
                                                                                 <Dropdown.Item to="#" onClick={() => readNotification(elm?.id, i)}><i className="ri-eye-fill me-2"></i>Mark as read</Dropdown.Item>
                                                                           }
                                                                           <Dropdown.Item to="#" onClick={() => deleteNotification(elm?.id, elm?.is_read !== 1)}><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                     </Dropdown>
                                                                  </div>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </li>
                                                   </ul>
                                                </Card.Body>
                                             </Card> :
                                             <Card>
                                                <Card.Body >
                                                   <ul className="notification-list m-0 p-0">
                                                      <li className="d-flex ">
                                                         <div className="user-img img-fluid"
                                                            onClick={(e) => {
                                                               e.stopPropagation();
                                                               navigate(profileData?.user_type === 4 ? "#" : `/dashboard/app/friend-profile/${elm?.user?.slug}`)
                                                            }}>
                                                            <img src={elm?.user?.user_setting?.photo ?
                                                               elm?.user?.user_setting?.photo :
                                                               "https://uzone360live.s3.amazonaws.com/noimage.png"}
                                                               alt="story-img" className="rounded-circle avatar-40" />
                                                         </div>
                                                         <div style={{ width: "97%" }}
                                                            onClick={(e) => {
                                                               // Same reasoning as the is_read===1 branch above -
                                                               // stop the wrapping <Link to="#"> from clobbering the
                                                               // real navigation generateURL() just performed.
                                                               e.preventDefault();
                                                               e.stopPropagation();
                                                               readNotification(elm?.id, i)
                                                               generateURL(elm)
                                                            }}>
                                                            <div className=" ms-3">
                                                               <h6>{elm?.description}</h6>
                                                               <p className="mb-0">{Moment(elm?.created_at).format('MMM D YYYY')}</p>
                                                            </div>
                                                         </div>
                                                         <div style={{ width: "3%" }}>
                                                            <div className="d-flex " style={{ alignItems: "right" }}>
                                                               <div className="d-flex align-items-center">
                                                                  <div className="card-header-toolbar d-flex align-items-center">
                                                                     <Dropdown>
                                                                        <Link to="#">
                                                                           <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                                              more_horiz
                                                                           </Dropdown.Toggle>
                                                                        </Link>
                                                                        <Dropdown.Menu className="dropdown-menu-right">
                                                                           {
                                                                              elm?.is_read !== 1 &&
                                                                                 <Dropdown.Item to="#" onClick={() => readNotification(elm?.id, i)}><i className="ri-eye-fill me-2"></i>Mark as read</Dropdown.Item>
                                                                           }
                                                                           <Dropdown.Item to="#" onClick={() => deleteNotification(elm?.id, elm?.is_read !== 1)}><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                     </Dropdown>
                                                                  </div>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </li>
                                                   </ul>
                                                </Card.Body>
                                             </Card>
                                       }
                                    </Link>
                                 ))
                              }
                              <InView as="div" onChange={(inView, entry) => loadMore(inView)} />
                           </div> : <NoDataFound />
                     }

                     {
                        showMoreDataLoader ?
                           <div className="col-sm-12 text-center">
                              <img src={loader} alt="loader" style={{ height: "100px" }} />
                           </div> : null
                     }
                     {/* <InView as="div" onChange={(inView, entry) => loadMore(inView)} /> */}

                     {/* <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user2} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className=" ms-3">
                                          <h6>Anne Fibbiyon Like Your Post</h6>
                                          <p className="mb-0">15  ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-danger rounded">
                                             <i className="material-symbols-outlined md-18">
                                                favorite_border
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user3} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Barry Cuda add Story</h6>
                                          <p className="mb-0">40  ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-primary rounded">
                                             <i className="material-symbols-outlined md-18">
                                                military_tech
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user4} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Cliff Hanger posted a comment on your status update</h6>
                                          <p className="mb-0">42  ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-success rounded">
                                             <i className="material-symbols-outlined md-16">
                                                chat_bubble_outline
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user4} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Rick O'Shea posted a comment on your photo</h6>
                                          <p className="mb-0">50  ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-success rounded">
                                             <i className="material-symbols-outlined md-16">
                                                chat_bubble_outline
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user5} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Brock Lee Sent a Friend Request</h6>
                                          <p className="mb-0">1 hour ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-warning rounded">
                                             <i className="material-symbols-outlined md-18">
                                                reply
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user6} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className=" ms-3">
                                          <h6>Ira Membrit shared your status update</h6>
                                          <p className="mb-0">1 hour ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-info rounded">
                                             <i className="material-symbols-outlined md-18">
                                                share
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user11} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Paul Molive and 3 ther have Birthday Today</h6>
                                          <p className="mb-0">3 houe ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-danger rounded">
                                             <i className="material-symbols-outlined md-18">
                                                cake
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user7} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Petey Cruiser Sent a Friend request</h6>
                                          <p className="mb-0">1 day ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-warning rounded">
                                             <i className="material-symbols-outlined md-18">
                                                reply
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user8} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Bob Frapples and 45 other Like Your Pst on timeline</h6>
                                          <p className="mb-0">1 week ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-danger rounded">
                                             <i className="material-symbols-outlined md-18">
                                                favorite_border
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user12} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Maya Didas share Your Post</h6>
                                          <p className="mb-0">1 month ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-info rounded">
                                             <i className="material-symbols-outlined md-18">
                                                share
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user9} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className=" ms-3">
                                          <h6>Sal Monella Add Photo with You</h6>
                                          <p className="mb-0">1 month ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-primary rounded">
                                             <i className="material-symbols-outlined md-18">
                                                military_tech
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user10} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="ms-3">
                                          <h6>Barb Dwyer commented on your new profile status</h6>
                                          <p className="mb-0">2 month ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-success rounded">
                                             <i className="material-symbols-outlined md-16">
                                                chat_bubble_outline
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user13} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className="info ms-3">
                                          <h6>Terry Aki commented on your new profile status</h6>
                                          <p className="mb-0">2 month ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-success rounded">
                                             <i className="material-symbols-outlined md-16">
                                                chat_bubble_outline
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card>
                     <Card>
                        <Card.Body>
                           <ul className="notification-list m-0 p-0">
                              <li className="d-flex align-items-center justify-content-between">
                                 <div className="user-img img-fluid">
                                    <img src={user14} alt="story-img" className="rounded-circle avatar-40" />
                                 </div>
                                 <div className="w-100">
                                    <div className="d-flex justify-content-between">
                                       <div className=" ms-3">
                                          <h6>Paige Turner Posted in Development Community</h6>
                                          <p className="mb-0">3 month ago</p>
                                       </div>
                                       <div className="d-flex align-items-center">
                                          <Link to="#" className="me-3 iq-notify bg-soft-primary rounded">
                                             <i className="material-symbols-outlined md-18 ">
                                                military_tech
                                             </i>
                                          </Link>
                                          <div className="card-header-toolbar d-flex align-items-center">
                                             <Dropdown>
                                                <Link to="#">
                                                   <Dropdown.Toggle as="span" className="material-symbols-outlined">
                                                      more_horiz
                                                   </Dropdown.Toggle>
                                                </Link>
                                                <Dropdown.Menu className="dropdown-menu-right">
                                                   <Dropdown.Item to="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                   <Dropdown.Item to="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card> */}
                  </Col>
               </Row>
            </Container>
         </div>

         {/* Registration Detail Modal for Teachers */}
         <RegistrationDetailModal
            show={showRegistrationModal}
            onHide={() => {
               setShowRegistrationModal(false);
               setRegistrationData(null);
            }}
            data={registrationData}
            loading={loadingRegistration}
            showEditButton={false}
         />

         {/* Generic Form Detail Modal for Types 13-22 */}
         <Modal 
            show={showFormModal}
            onHide={() => {
               setShowFormModal(false);
               setFormModalType(null);
               setFormModalData(null);
               setShowLeaveDecisionSection(null);
               setLeaveAdminComments('');
            }}
            size="lg"
            centered
         >
            <Modal.Header closeButton>
               <Modal.Title>
                  {formModalType === 'illness' && 'Illness Report'}
                  {formModalType === 'accident' && 'Accident Report'}
                  {formModalType === 'allergy' && 'Allergy Action Plan'}
                  {formModalType === 'lunch' && 'Lunch Plan Waiver'}
                  {formModalType === 'peanut' && 'No Peanut Policy'}
                  {formModalType === 'emergency' && 'Emergency Contact'}
                  {formModalType === 'dailyReport' && 'Daily Report'}
                  {formModalType === 'medication' && 'Medication Administered'}
                  {formModalType === 'leave' && 'Leave Application'}
                  {formModalType === 'nonMedication' && 'Non-Medication Administered'}
               </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{
               padding: '0',
               maxHeight: 'calc(80vh - 120px)',
               overflowY: 'auto',
               background: '#f8fafc'
            }}>
               {!formModalData ? (
                  <div className="text-center p-4" style={{ background: 'white' }}>
                     <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                     </div>
                     <p className="mt-3">Loading form details...</p>
                  </div>
               ) : (
                  <div style={{ padding: '20px' }}>
                     {/* Illness Report */}
                     {formModalType === 'illness' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                       Student Name
                                    </div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.student_name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                       Report Date
                                    </div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.created_at ? Moment(formModalData.created_at).format('MMM D, YYYY h:mm A') : 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                       Expected Return Date
                                    </div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.return_date ? Moment(formModalData.return_date).format('MMM D, YYYY') : 'N/A'}
                                    </div>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                       Symptoms
                                    </div>
                                    <div
                                       style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}
                                       dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formModalData.symptoms || 'N/A') }}
                                    />
                                 </div>
                              </Col>
                           </Row>
                           {formModalData.requested_action_parent && (
                              <Row>
                                 <Col xs={12}>
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                          Requested Action by Parent
                                       </div>
                                       <div
                                          style={{
                                             fontSize: '14px',
                                             color: '#495057',
                                             padding: '12px',
                                             background: '#f8f9fa',
                                             borderRadius: '8px',
                                             border: '1px solid #dee2e6'
                                          }}
                                          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formModalData.requested_action_parent) }}
                                       />
                                    </div>
                                 </Col>
                              </Row>
                           )}
                           {formModalData.teacher_signature && (
                              <Row className="mt-3">
                                 <Col xs={12}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '8px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                       Teacher Signature
                                    </div>
                                    <img src={formModalData.teacher_signature} alt="Teacher Signature" style={{
                                       maxWidth: '100%',
                                       width: '200px',
                                       border: '1px solid #ddd',
                                       padding: '5px',
                                       borderRadius: '8px'
                                    }} />
                                 </Col>
                              </Row>
                           )}
                        </div>
                     )}
                     
                     {/* Accident Report */}
                     {formModalType === 'accident' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Student Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.student_name || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Date</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.date ? Moment(formModalData.date).format('MMM D, YYYY') : 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Time</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.time || 'N/A'}</div>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Location</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.location || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Parent Contacted</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.parent_contacted === 1 ? 'Yes' : formModalData.parent_contacted === 0 ? 'No' : 'N/A'}
                                    </div>
                                 </div>
                              </Col>
                           </Row>
                           <Row>
                              <Col xs={12}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Description</div>
                                    <div
                                       style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}
                                       dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formModalData.description || 'N/A') }}
                                    />
                                 </div>
                              </Col>
                              <Col xs={12}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>First Aid / Action Taken</div>
                                    <div
                                       style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}
                                       dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formModalData.action_taken || 'N/A') }}
                                    />
                                 </div>
                              </Col>
                           </Row>
                           {(formModalData.staff_signature || formModalData.supervisor_signature || formModalData.parent_signature) && (
                              <Row className="mt-2">
                                 {formModalData.staff_signature && (
                                    <Col xs={12} sm={4} className="mb-3">
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Staff Signature</div>
                                       <img src={formModalData.staff_signature} alt="Staff Signature" style={{ maxWidth: '100%', height: '60px', border: '1px solid #e5e7eb', borderRadius: '4px' }} />
                                    </Col>
                                 )}
                                 {formModalData.supervisor_signature && (
                                    <Col xs={12} sm={4} className="mb-3">
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Supervisor Signature</div>
                                       <img src={formModalData.supervisor_signature} alt="Supervisor Signature" style={{ maxWidth: '100%', height: '60px', border: '1px solid #e5e7eb', borderRadius: '4px' }} />
                                    </Col>
                                 )}
                                 {formModalData.parent_signature && (
                                    <Col xs={12} sm={4} className="mb-3">
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>
                                          Parent Signature{formModalData.parent_signature_date ? ` (${Moment(formModalData.parent_signature_date).format('MMM D, YYYY')})` : ''}
                                       </div>
                                       <img src={formModalData.parent_signature} alt="Parent Signature" style={{ maxWidth: '100%', height: '60px', border: '1px solid #e5e7eb', borderRadius: '4px' }} />
                                    </Col>
                                 )}
                              </Row>
                           )}
                        </div>
                     )}

                     {/* Emergency Contact */}
                     {formModalType === 'emergency' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.contact_name || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    {/* The model only has relation/phone/contact_name - Email,
                                        Address, and Authorized for Pickup below were removed
                                        since this form never captured that data at all (always
                                        showed N/A/No). */}
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Relationship</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.relation || 'N/A'}</div>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Phone</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.phone || 'N/A'}</div>
                                 </div>
                              </Col>
                           </Row>
                        </div>
                     )}
                     
                     {/* Leave Application */}
                     {formModalType === 'leave' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Student Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.student_name || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Leave Type</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.leave_type || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>From Date</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.from_date ? Moment(formModalData.from_date).format('MMM D, YYYY') : 'N/A'}</div>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>To Date</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.to_date ? Moment(formModalData.to_date).format('MMM D, YYYY') : 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Status</div>
                                    <Badge bg={formModalData.status === 'Approved' ? 'success' : formModalData.status === 'Rejected' ? 'danger' : 'warning'}>{formModalData.status || 'Pending'}</Badge>
                                 </div>
                              </Col>
                           </Row>
                           <Row>
                              <Col xs={12}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Reason</div>
                                    <div style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                       {formModalData.reason || 'N/A'}
                                    </div>
                                 </div>
                              </Col>
                           </Row>

                           {/* Approve/reject controls - only for a teacher viewing one of
                               their own students' still-pending applications. */}
                           {isTeacherLoginProfile(profileData) && formModalData.status === 'Pending' && (
                              <div className="mt-3 pt-3" style={{ borderTop: '1px solid #dee2e6' }}>
                                 {showLeaveDecisionSection === null && (
                                    <div className="d-flex gap-2">
                                       <Button variant="success" size="sm" onClick={() => setShowLeaveDecisionSection('approve')}>
                                          <i className="ri-check-line"></i> Approve
                                       </Button>
                                       <Button variant="outline-danger" size="sm" onClick={() => setShowLeaveDecisionSection('reject')}>
                                          <i className="ri-close-line"></i> Reject
                                       </Button>
                                    </div>
                                 )}

                                 {showLeaveDecisionSection === 'approve' && (
                                    <div>
                                       <Form.Group className="mb-3">
                                          <Form.Label>Comments (Optional)</Form.Label>
                                          <Form.Control
                                             as="textarea"
                                             rows={2}
                                             value={leaveAdminComments}
                                             onChange={(e) => setLeaveAdminComments(e.target.value)}
                                             placeholder="Add any comments regarding the approval..."
                                          />
                                       </Form.Group>
                                       <Form.Group className="mb-3">
                                          <Form.Label>Your Signature <span className="text-danger">*</span></Form.Label>
                                          <div className="border rounded p-2 bg-white" style={{ width: '100%', height: '160px' }}>
                                             <SignatureCanvas
                                                ref={leaveSignaturePadRef}
                                                canvasProps={{
                                                   className: 'signature-canvas',
                                                   style: { width: '100%', height: '100%' }
                                                }}
                                             />
                                          </div>
                                          <Button variant="outline-secondary" size="sm" className="mt-2" onClick={handleClearLeaveSignature} type="button">
                                             Clear Signature
                                          </Button>
                                       </Form.Group>
                                       <div className="d-flex gap-2">
                                          <Button variant="secondary" size="sm" onClick={() => { setShowLeaveDecisionSection(null); setLeaveAdminComments(''); }} disabled={isSubmittingLeaveDecision}>
                                             Cancel
                                          </Button>
                                          <Button variant="success" size="sm" onClick={handleApproveLeaveApplication} disabled={isSubmittingLeaveDecision}>
                                             {isSubmittingLeaveDecision ? 'Approving...' : 'Approve Application'}
                                          </Button>
                                       </div>
                                    </div>
                                 )}

                                 {showLeaveDecisionSection === 'reject' && (
                                    <div>
                                       <Form.Group className="mb-3">
                                          <Form.Label>Reason for Rejection <span className="text-danger">*</span></Form.Label>
                                          <Form.Control
                                             as="textarea"
                                             rows={2}
                                             value={leaveAdminComments}
                                             onChange={(e) => setLeaveAdminComments(e.target.value)}
                                             placeholder="Please provide the reason for rejecting this application..."
                                          />
                                       </Form.Group>
                                       <div className="d-flex gap-2">
                                          <Button variant="secondary" size="sm" onClick={() => { setShowLeaveDecisionSection(null); setLeaveAdminComments(''); }} disabled={isSubmittingLeaveDecision}>
                                             Cancel
                                          </Button>
                                          <Button variant="danger" size="sm" onClick={handleRejectLeaveApplication} disabled={isSubmittingLeaveDecision}>
                                             {isSubmittingLeaveDecision ? 'Rejecting...' : 'Reject Application'}
                                          </Button>
                                       </div>
                                    </div>
                                 )}
                              </div>
                           )}
                        </div>
                     )}
                     
                     {/* Allergy, Lunch, Peanut, Medication, Non-Medication, Daily Report */}
                     {formModalType === 'allergy' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Student Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.student_name || formModalData.child_name || formModalData.user?.first_name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Symptoms/Allergies</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.allergies || formModalData.symptoms || formModalData.allergy_type || formModalData.allergy_name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Severity</div>
                                    <Badge bg={formModalData.severity === 'severe' ? 'danger' : formModalData.severity === 'moderate' ? 'warning' : 'info'}>{formModalData.severity || 'Moderate'}</Badge>
                                 </div>
                                 {formModalData.require_epi_pen !== undefined && (
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Requires EpiPen</div>
                                       <Badge bg={formModalData.require_epi_pen ? 'danger' : 'secondary'}>{formModalData.require_epi_pen ? 'Yes' : 'No'}</Badge>
                                    </div>
                                 )}
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Emergency Treatment</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.treatment || formModalData.emergency_treatment_procedures || formModalData.emergency_treatment || 'N/A'}
                                    </div>
                                 </div>
                                 {formModalData.location_of_epi_pen && (
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>EpiPen Location</div>
                                       <div style={{ fontSize: '14px', fontWeight: '600', color: '#d32f2f' }}>{formModalData.location_of_epi_pen}</div>
                                    </div>
                                 )}
                                 {formModalData.signature && (
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '8px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Parent Signature</div>
                                       <img 
                                          src={formModalData.signature} 
                                          alt="Parent Signature" 
                                          style={{
                                             maxWidth: '100%', 
                                             width: '200px', 
                                             border: '1px solid #ddd', 
                                             padding: '5px', 
                                             borderRadius: '8px'
                                          }} 
                                          onError={(e) => { 
                                             e.target.style.display = 'none'; 
                                             e.target.parentElement.innerHTML += `<div style="fontSize: 14px; fontWeight: 600; color: #212529;">${formModalData.signature}</div>`;
                                          }}
                                       />
                                    </div>
                                 )}
                                 {formModalData.signed_date && (
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Signed Date</div>
                                       <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                          {Moment(formModalData.signed_date).format('MMM D, YYYY')}
                                       </div>
                                    </div>
                                 )}
                              </Col>
                           </Row>
                           {(formModalData.notes || formModalData.additional_information) && (
                              <Row>
                                 <Col xs={12}>
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Additional Information</div>
                                       <div style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                          {formModalData.notes || formModalData.additional_information}
                                       </div>
                                    </div>
                                 </Col>
                              </Row>
                           )}
                        </div>
                     )}

                     {formModalType === 'lunch' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Student Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.student_name || formModalData.child_name || formModalData.user?.first_name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Submitted Date</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.submitted_date ? Moment(formModalData.submitted_date).format('MMM D, YYYY') : 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Status</div>
                                    <Badge bg={formModalData.status === 'active' ? 'success' : 'secondary'}>{formModalData.status === 'active' ? 'Active' : 'Inactive'}</Badge>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Parent Signature Date</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.signed_date ? Moment(formModalData.signed_date).format('MMM D, YYYY') : 'N/A'}</div>
                                 </div>
                              </Col>
                           </Row>
                           {formModalData.reason && (
                              <Row>
                                 <Col xs={12}>
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Reason</div>
                                       <div style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                          {formModalData.reason}
                                       </div>
                                    </div>
                                 </Col>
                              </Row>
                           )}
                           {(formModalData.parent_signature || formModalData.supervisor_signature) && (
                              <Row className="mt-3">
                                 {formModalData.parent_signature && (
                                    <Col xs={12} sm={6}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '8px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Parent Signature</div>
                                       <img src={formModalData.parent_signature} alt="Parent Signature" style={{maxWidth: '100%', width: '200px', border: '1px solid #ddd', padding: '5px', borderRadius: '8px'}} />
                                    </Col>
                                 )}
                                 {formModalData.supervisor_signature && (
                                    <Col xs={12} sm={6}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '8px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Supervisor Signature</div>
                                       <img src={formModalData.supervisor_signature} alt="Supervisor Signature" style={{maxWidth: '100%', width: '200px', border: '1px solid #ddd', padding: '5px', borderRadius: '8px'}} />
                                    </Col>
                                 )}
                              </Row>
                           )}
                        </div>
                     )}

                     {formModalType === 'peanut' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Student Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.student_name || formModalData.child_name || formModalData.user?.first_name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Policy Acknowledged</div>
                                    <Badge bg={(formModalData.acknowledged || formModalData.is_acknowledged || formModalData.policy_acknowledged) ? 'success' : 'danger'}>
                                       {(formModalData.acknowledged || formModalData.is_acknowledged || formModalData.policy_acknowledged) ? 'Yes' : 'No'}
                                    </Badge>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Date Signed</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {(formModalData.signed_date || formModalData.date_signed || formModalData.signature_date || formModalData.created_at) ? 
                                          Moment(formModalData.signed_date || formModalData.date_signed || formModalData.signature_date || formModalData.created_at).format('MMM D, YYYY') : 'N/A'}
                                    </div>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Parent Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.parent_name || formModalData.guardian_name || formModalData.parent_guardian_name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Has Peanut Allergy</div>
                                    <Badge bg={(formModalData.has_peanut_allergy || formModalData.has_allergy || formModalData.peanut_allergy) ? 'warning' : 'secondary'}>
                                       {(formModalData.has_peanut_allergy || formModalData.has_allergy || formModalData.peanut_allergy) ? 'Yes' : 'No'}
                                    </Badge>
                                 </div>
                              </Col>
                           </Row>
                           {(formModalData.signature || formModalData.parent_signature || formModalData.guardian_signature) && (
                              <Row className="mt-3">
                                 <Col xs={12}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '8px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Parent Signature</div>
                                    <img src={formModalData.signature || formModalData.parent_signature || formModalData.guardian_signature} alt="Parent Signature" style={{maxWidth: '100%', width: '200px', border: '1px solid #ddd', padding: '5px', borderRadius: '8px'}} />
                                 </Col>
                              </Row>
                           )}
                           {/* Debug info - remove after testing */}
                           {console.log('Peanut Policy Data:', formModalData)}
                        </div>
                     )}

                     {formModalType === 'medication' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Student Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.student_name || formModalData.child_name || formModalData.user?.first_name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Medication Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.medication_name || formModalData.medicine_name || formModalData.name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Dosage</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.dosage || formModalData.dose || 'N/A'}</div>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Time Administered</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.administered_time ? Moment(formModalData.administered_time).format('MMM D, YYYY h:mm A') : 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Administered By</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.administered_by || formModalData.teacher_name || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Frequency</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.frequency || 'N/A'}</div>
                                 </div>
                              </Col>
                           </Row>
                           {formModalData.notes && (
                              <Row>
                                 <Col xs={12}>
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Notes</div>
                                       <div style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                          {formModalData.notes}
                                       </div>
                                    </div>
                                 </Col>
                              </Row>
                           )}
                        </div>
                     )}

                     {formModalType === 'nonMedication' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Student Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.student_name || formModalData.child_name || formModalData.user?.first_name || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Treatment Type</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>
                                       {formModalData.treatment_type || formModalData.non_medication_type || formModalData.type || 'N/A'}
                                    </div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Time</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.treatment_time ? Moment(formModalData.treatment_time).format('MMM D, YYYY h:mm A') : 'N/A'}</div>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Applied By</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.applied_by || formModalData.teacher_name || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Reason</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.reason || formModalData.purpose || 'N/A'}</div>
                                 </div>
                              </Col>
                           </Row>
                           {formModalData.description && (
                              <Row>
                                 <Col xs={12}>
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Description</div>
                                       <div style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                          {formModalData.description}
                                       </div>
                                    </div>
                                 </Col>
                              </Row>
                           )}
                        </div>
                     )}

                     {formModalType === 'dailyReport' && formModalData && (
                        <div style={{
                           background: 'white',
                           borderRadius: '12px',
                           padding: '20px',
                           boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                           border: '1px solid #e5e7eb'
                        }}>
                           <Row className="mb-3">
                              <Col xs={12}>
                                 <h6 style={{ 
                                    fontSize: '15px',
                                    fontWeight: '700',
                                    color: 'var(--bs-primary)',
                                    marginBottom: '20px',
                                    paddingBottom: '12px',
                                    borderBottom: '2px solid #e5e7eb'
                                 }}>
                                    Daily Report Summary
                                 </h6>
                              </Col>
                              <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Student Name</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.student_name || formModalData.child_name || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Date</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.report_date ? Moment(formModalData.report_date).format('MMM D, YYYY') : 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Mood</div>
                                    <Badge bg="info">{formModalData.mood || 'N/A'}</Badge>
                                 </div>
                              </Col>
                              <Col xs={12} sm={6}>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Meals</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.meals || formModalData.meal_status || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Nap Time</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.nap_time || formModalData.sleep_duration || 'N/A'}</div>
                                 </div>
                                 <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Bathroom</div>
                                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#212529' }}>{formModalData.bathroom || formModalData.diaper_changes || 'N/A'}</div>
                                 </div>
                              </Col>
                           </Row>
                           {formModalData.activities && (
                              <Row className="mb-3">
                                 <Col xs={12}>
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Activities</div>
                                       <div style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                          {formModalData.activities}
                                       </div>
                                    </div>
                                 </Col>
                              </Row>
                           )}
                           {formModalData.notes && (
                              <Row>
                                 <Col xs={12}>
                                    <div style={{ marginBottom: '16px' }}>
                                       <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '5px', textTransform: 'uppercase', fontWeight: '600', letterSpacing: '0.5px' }}>Teacher Notes</div>
                                       <div style={{ fontSize: '14px', color: '#495057', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                          {formModalData.notes}
                                       </div>
                                    </div>
                                 </Col>
                              </Row>
                           )}
                        </div>
                     )}
                  </div>
               )}
            </Modal.Body>
            <Modal.Footer>
               <button
                  className="btn btn-secondary"
                  onClick={() => {
                     setShowFormModal(false);
                     setFormModalType(null);
                     setFormModalData(null);
                     setShowLeaveDecisionSection(null);
                     setLeaveAdminComments('');
                  }}
               >
                  Close
               </button>
            </Modal.Footer>
         </Modal>
      </ErrorBoundary>
   )
}

export default Notification